import type { PortfolioBalanceCalculationMessage } from '@festina/unitlink-general-types/unitlink'
import { PortfoliosBalanceService } from '@festina/unitlink-general-types/unitlink/services/PortfoliosBalanceService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  PortfoliosBalanceService.portfolioBalanceServicePostCalculateAndUpdate

type Props = {
  tenantId: string
  ownerId: string
}

export const useCreateUpdateBalance = ({ ownerId, tenantId }: Props) =>
  useFestinaMutation({
    component: 'unitLink',
    roles:
      PortfoliosBalanceService.portfolioBalanceServicePostCalculateAndUpdate_roles,
    isScenario: false,
    mutateFunction: async (requestBody: PortfolioBalanceCalculationMessage) => {
      await method({
        xTenantId: tenantId,
        ownerId,
        requestBody,
      })
    },
  })
